export const ALPHA_NUMERIC = /^([a-zA-Z0-9_-]+)$/

export const IS_NUMBER = /^[0-9.,]+$/

/**
 * Regular expression allowing a grade between 0 and 10
 * @example
 * Allowed values:
 * ['10', '8.10', '2.3', '7,12']
 */
export const REGEXP_ALLOWED_GRADE = /^(10(\.0+)?|[0-9](\.\d+)?)$/

/**
 * Regular expression that allows only numerical values and does not allow the value e
 * @example
 * Allowed values:
 * ['11', '10.10', '20,100', '7.', '3,']
 * @example
 * Not allowed values:
 * ['e', ' ', '%']
 */
export const REGEXP_IS_NUMBER = /^(?!.*e)[\d.]+$/
